import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LoadingErrorState } from '../components/LoadingErrorState';
import UpdateJobListing from '../components/forms/UpdateJobListing';
import toast from 'react-hot-toast';
import { fetchJobListings } from '../hooks/queries';

const JobListing: React.FC = () => {
  const {
    isLoading,
    isFetching,
    error,
    refetch,
    data: jobListings,
  } = fetchJobListings();

  const { id } = useParams();
  const navigate = useNavigate();

  const currentJobListing = jobListings?.data?.find(
    (jobListing) => jobListing._id === id
  );

  return (
    <div className="w-full relative max-w-5xl 2xl:max-w-7xl mx-auto">
      <LoadingErrorState
        isLoading={isLoading}
        isFetching={isFetching}
        error={error}
        refetch={refetch}
        data={currentJobListing}
      />
      {!isLoading && !isFetching && !error && currentJobListing && (
        <UpdateJobListing
          currentJobListing={currentJobListing}
          onSuccess={() => {
            refetch();
            toast.success('Job listing updated successfully');
            navigate('/job-listings');
          }}
          onError={(error) => toast.error(error.message)}
        />
      )}
    </div>
  );
};

export default JobListing;
